'use client';

import { useEffect } from 'react';
import { ErrorScreen } from '@/components/ui/error-screen';
import { reportCaughtError } from '@/lib/analytics/posthog';

/**
 * Any page that throws while rendering lands here instead of Next's bare
 * "Application error" screen, and the error is reported to PostHog.
 */
export default function RouteError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    reportCaughtError(error, 'route');
  }, [error]);
  return <ErrorScreen onRetry={reset} />;
}
